

























import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { jointGoodsModelProvider } from '../model'

export default defineClassComponent(
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      // 营销数据
      marketingData = computed(() => this.jointGoodsModel.value.marketingData)
    },
)
